import React from 'react'
import { connect } from 'react-redux'
import { getArticleFeedbackData } from 'modules/reports/articleFeedback/selectors'
import cx from 'classnames'

import './style.css'

const PERCENTAGE_THRESHOLD = 69
const EMPTY_DISPLAY = '—'

const ArticleFeedbackReport = ({ article, voteData, feedbackType }) => {
  const articleID = article.id
  
  let voteNumber = 0
  let percentage = 0
  
  if (voteData && voteData[articleID]) {
    const report = voteData[articleID]
    const totalNumberOfVotes = report.data.POSITIVE + report.data.NEGATIVE
    voteNumber = feedbackType === "upvote" ? report.data.POSITIVE : report.data.NEGATIVE
    percentage = Math.round((voteNumber / totalNumberOfVotes) * 100)
  } else {
    voteNumber = EMPTY_DISPLAY
    percentage = null
  }
  
  return (
    <span
      className={cx({
        "article-downvote-wrapper": feedbackType === "downvote",
        "article-upvote-wrapper": feedbackType === "upvote"
      })}>
			<span
        className={cx({
          "article-downvote-count": feedbackType === "downvote",
          "article-upvote-count": feedbackType === "upvote",
          "article-vote-threshold": feedbackType === "downvote" && percentage > PERCENTAGE_THRESHOLD,
          "article-vote-empty": voteNumber === EMPTY_DISPLAY
        })}>
        {voteNumber}
      </span>
			<span className={cx({
        "article-downvote-percentage": feedbackType === "downvote",
        "article-upvote-percentage": feedbackType === "upvote",
        "article-vote-threshold": feedbackType === "downvote" && percentage > PERCENTAGE_THRESHOLD
      })}>
        {percentage == null ? percentage : `${percentage}%`}
			</span>
		</span>
  )
}

const mapStateToProps = state => ({
  voteData: getArticleFeedbackData(state)
})

export default connect(mapStateToProps)(ArticleFeedbackReport)